import { createAction, props } from "@ngrx/store"
import { MoveToBankDto, MoveToBankRequestDto, NotifyDto } from "./txn.dtos"

export const fetchTransactions = createAction(
    '[Transactions Module] fetch transactions',
    props<{timestamp: Date, startDate: string, endDate: string}>()
)

export const fetchTransactionsFailed = createAction(
    '[Transactions Module] STATUS: fetch transactions failed'
)

export const fetchTransactionsSuccess = createAction(
    '[Transactions Module] STATUS: fetch transactions success',
    props<{transactions}>()
)



export const createMoveToBankRequest = createAction(
    '[Transactions Module] create move to bank request',
    props<{moveToBankRequestDto: MoveToBankRequestDto}>()
)

export const createMoveToBankRequestFailed = createAction(
    '[Transactions Module] STATUS: create move to bank request failed'
)

export const createMoveToBankRequestSuccess = createAction(
    '[Transactions Module] STATUS: create move to bank request success',
    props<{processId: string}>()
)


export const moveToBank = createAction(
    '[Transactions Module]  move to bank',
    props<{moveToBankDto: MoveToBankDto}>()
)

export const moveToBankFailed = createAction(
    '[Transactions Module] STATUS:  move to bank failed'
)

export const moveToBankSuccess = createAction(
    '[Transactions Module] STATUS:  move to bank success'
)



export const fetchDebit = createAction(
    '[Transactions Module] fetch debit',
    props<{productId: string}>()
)

export const fetchDebitFailed = createAction(
    '[Transactions Module] STATUS: fetch debit failed'
)

export const fetchDebitSuccess = createAction(
    '[Transactions Module] STATUS: fetch debit success',
    props<{debitDetails}>()
)


export const checkSignatures = createAction(
    '[Transactions Module] check signatures',
    props<{paymentId: string}>()
)

export const checkSignaturesFailed = createAction(
    '[Transactions Module] STATUS: check signatures failed'
)

export const checkSignaturesSuccess = createAction(
    '[Transactions Module] STATUS: check signatures success',
    props<{signaturesResult}>()
)


export const notifyAuthorizers = createAction(
    '[Transactions Module] notify authorizers',
    props<{notifyDto: NotifyDto}>()
)

export const notifyAuthorizersFailed = createAction(
    '[Transactions Module] STATUS: notify authorizers failed',
    props<{error: {error: string, message: string}}>()
)

export const notifyAuthorizersSuccess = createAction(
    '[Transactions Module] STATUS: notify authorizers success'
)
